exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".products-grid-tile {\n  border: 3px solid #FF6A6A !important;\n  border-radius: 4px !important; }\n  .products-grid-tile img {\n    width: 40% !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/productsGrid.scss
// module id = 689
// module chunks = 0